import BaseService from "./BaseService";

class QuotationService {
  static async GetQuotations(id, password, token = null, page = 1, pageSize = 10, filters = {}, config = {}) {
    try {
      if (password) {
        return await BaseService.get(`quotations/${id}/password/${password}`);
      }
      else if (id) {
        return await BaseService.get(`quotations/${id}`, token);
      }

      const queryParams = new URLSearchParams({
        page: String(page),
        pageSize: String(pageSize),
      });

      Object.entries(filters || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          queryParams.append(key, value);
        }
      });

      return await BaseService.get(`quotations?${queryParams.toString()}`, token, null, config);
    } catch (error) {
      console.error("There was an error fetching the users!", error);
      throw error;
    }
  }
  static async postQuotations(data, token) {
    try {
      return await BaseService.post("quotations", data, token);
    } catch (error) {
      console.error("There was an error posting the user!", error);
      throw error;
    }
  }
  static async UpdateQuotation(Id, data, token, params = {}) {
    try {
      return await BaseService.put("quotations", Id, data, token, params);
    } catch (error) {
      console.error("There was an error editing the user!", error);
      throw error;
    }
  }

  static async deleteQuotations(Id, token) {
    try {
      return await BaseService.delete("quotations", Id, token);
    } catch (error) {
      console.error("There was an error deleting the user!", error);
      throw error;
    }
  }
}

export default QuotationService;
